<template>
  <validation-observer v-slot="{ handleSubmit }">
    <div class="row">
      <div class="col-md-12 text-bold bold mb-3">
        <i class="fa fa-redo-alt color-orange" />
        {{ title }}
      </div>
      <div class="col-md-4">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-date-picker
            v-model="model.receptionDate"
            class-container="w-100"
            custom-error-msg="Favor seleccione la fecha de recepción."
            :error="errors[0]"
            label="Fecha:"
            :max-date="new Date()"
            :min-date="beforeBankRequestDate"
            placeholder="DD/MM/YYYY"
          />
        </validation-provider>
      </div>
      <div class="col-md-12 mt-2">
        <custom-text-area
          v-model="model.comment"
          label="Comentario:"
          :maxlength="500"
          :rows="4"
          show-char-count
        />
      </div>

      <div class="col-md-12 text-right mt-3 pt-1">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3"
          @click="$emit('on-cancel')"
        />
        <action-button
          i="fas fa-save"
          text="Guardar"
          variant="success"
          @click="handleSubmit(submit)"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import CustomDatePicker from 'custom-date-picker';
import alertMixin from '@/mixins/alert.mixin';
import { putSingleReceived } from '@/modules/shared/cardHandling.api';
import moment from 'moment';
export default {
  name: 'SingleReceivedCard',
  components: {
    CustomTextArea,
    CustomDatePicker,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
      default: 0,
      require: true,
    },
    bankRequestDate: {
      type: Date,
      default: null,
    },
    title: {
      type: String,
      default: null,
      require: true,
    },
  },
  data: () => ({
    model: {},
  }),
  computed: {
    beforeBankRequestDate() {
      return moment(this.bankRequestDate)
        .subtract(1, 'days')
        .toDate();
    },
  },
  methods: {
    async submit() {
      this.model.becaCardId = this.id;
      await putSingleReceived(this.model)
        .then(() => {
          this.ShowToast(
            'Confirmación',
            'La recepción ha sido realizada exitosamente.',
            'success'
          );
          this.$emit('on-saved');
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
  },
};
</script>
<style scoped lang="scss"></style>
